import { markerKDag, markerKDagVariables } from 'pages/custom/KDag/markerKDag';
import {
    Kontakt2023Marker,
    kontakt2023MarkerVariables
} from 'pages/custom/Kontakt2023/Kontakt2023Marker';
import {
    Kontakt2024Marker,
    kontakt2024MarkerVariables
} from 'pages/custom/Kontakt2023/Kontakt2024Marker';
import { PerFEKTMarker, perFEKTMarkerVariables } from 'pages/custom/perFEKT/PerFEKTMarker';
import { markerRevolve, markerRevolveVariables } from 'pages/custom/Revolve/markerRevolve';
import { IconButtonMarker, IconButtonVariables } from 'pages/custom/shared/marker/IconButtonMarker';
import { markerUIA, markerUIAVariables } from 'pages/custom/UIA/markerUIA';

interface MarkerDefinition {
    componentTypeId: string;
    variables: Array<{ variableName: string; type: 'string' | 'boolean' | 'number' }>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    builder: (props: any) => JSX.Element;
}

export const CUSTOM_MARKERS_LIST: MarkerDefinition[] = [
    {
        componentTypeId: 'karrierdagen-uia',
        variables: markerUIAVariables,
        builder: markerUIA
    },
    {
        componentTypeId: 'revolve',
        variables: markerRevolveVariables,
        builder: markerRevolve
    },
    {
        componentTypeId: 'kdag',
        variables: markerKDagVariables,
        builder: markerKDag
    },
    {
        componentTypeId: 'kontakt2023-fair',
        variables: kontakt2023MarkerVariables,
        builder: Kontakt2023Marker
    },
    {
        componentTypeId: 'kontakt2024-fair',
        variables: kontakt2024MarkerVariables,
        builder: Kontakt2024Marker
    },
    {
        componentTypeId: 'perfekt2023-fair',
        variables: perFEKTMarkerVariables,
        builder: PerFEKTMarker
    },
    {
        componentTypeId: 'iconbutton',
        variables: IconButtonVariables,
        builder: IconButtonMarker
    }
];

export const CUSTOM_MARKER_BUILDERS = Object.fromEntries(
    CUSTOM_MARKERS_LIST.map((e) => [e.componentTypeId, e.builder])
);
